import { useContext } from "react";
import { ProjectProcessContext } from "./project-process-context-props";

export const useOptionalProjectProcessContext = () => useContext(ProjectProcessContext);

const useProjectProcessContext = () => {
    const context = useOptionalProjectProcessContext();

    if (!context) {
        throw new Error("useProjectProcessContext must be used within a ProjectProcessProvider");
    }

    return context;
};

export default useProjectProcessContext;
